import { Spinner } from '@wordpress/components';

function showSpinner() {
	return <Spinner />;
}

export default showSpinner;
